import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { Component, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { NgIf } from '../../../../node_modules/@angular/common';

import { GTMIdentifierTypes } from '@utilities/enums/gtm-identifiers.enum';

import { CustomerHttpService } from '@services/customer-http/customer-http.service';
import { PersonalDetailsModel } from '@services/customer-http/models/customer.model';
import { DataLayerEventsService } from '@services/data-layer/data-layer.service';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tax-years-list',
  imports: [NgIf],
  templateUrl: './tax-years-list.component.html',
  styleUrl: './tax-years-list.component.scss',
})
export class TaxYearsListComponent implements OnInit {
  selectedYear: number | null = null;
  private subscription = new Subscription();
  is2025Available: boolean = true;
  private gTMIdentifierTypes: typeof GTMIdentifierTypes = GTMIdentifierTypes;

  constructor(
    private customerHttpService: CustomerHttpService,
    private dataLayerEventsService: DataLayerEventsService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.customerHttpService.getPersonalDetails().subscribe({
        next: (answer: PersonalDetailsModel) => {
          this.is2025Available = true;
        },
        error: (errorResponse: HttpErrorResponse) => {
          if (errorResponse.status === 460) {
            this.is2025Available = false;

            let model;
            if (localStorage.getItem('partner')) {
              model = {
                partner: localStorage.getItem('partner'),
              };
            }
            this.customerHttpService.updateProfile(model).subscribe({
              next: res => {
                if (res && res.status === 233) {
                  this.dataLayerEventsService.submitGtmEvent(this.gTMIdentifierTypes.ActiveAccount);
                }
                localStorage.removeItem('partner');
              },
              error: (errorResponse: HttpErrorResponse) => {
                console.log(errorResponse);
              },
            });
          }
          console.log(errorResponse);
        },
      })
    );
  }

  onContinue(): void {
    if (!this.selectedYear) {
      return;
    }

    window.open(environment.auPairURLS[this.selectedYear!], '_self');
  }
}
